require("../../scss/app-ship.scss");

import TabsBehaviour from "../behaviours/tabs-behaviour";
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";
import ShortlistCount from '../jsx/shortlist/shortlist-count';
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import EmbeddedGallery from '../jsx/embedded-gallery';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ScrollToBehaviour from "../behaviours/scroll-to-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import BackgroundImageBehaviour from "../behaviours/background-image-behaviour";
import Gallery from "../jsx/gallery";
import DeckPlanBehaviour from "../behaviours/deck-plan-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import Application from "./application";

let config = {};
config.behaviours = {
    'TabsBehaviour': new TabsBehaviour(),
    'MobileMenuBehaviour': new MobileMenuBehavior(),
    'ScrollToBehaviour': new ScrollToBehaviour(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'BackgroundImageBehaviour': new BackgroundImageBehaviour(),
    'DeckPlanBehaviour': new DeckPlanBehaviour(),
    'EqualizeBehavior': new EqualizeBehavior(),
    'AccordionBehaviour': new AccordionBehaviour(),
    'HideShowBehaviour': new HideShowBehaviour(),
    'StickyNavBehaviour': new StickyNavBehaviour(),
    'BlockEventBehaviour': new BlockEventBehaviour(),
    'CarouselBehaviour': new CarouselBehaviour(),
};

config.components = {
    'shortlist-count': ShortlistCount,
    'shortlist-button': ShortlistButton,
    'embedded-gallery': EmbeddedGallery,
    'gallery': Gallery,
}

new Application(config);
